import Styles from "./NSBarNotification.module.css";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { useEffect } from "react";

export interface NSBarNotificationProps extends IBaseComponentProps
{
    id: string;
    text: string;
    type: NotificationType;
    color: NSBarNotificationColor;
    expired_at?: Date;
}

export interface NSBarNotificationPropsInner extends NSBarNotificationProps
{
    onClose: () => void;
    onChangeState: () => void;
}

export enum NSBarNotificationColor
{
    GRAY = "GRAY",
    BLUE = "BLUE",
    GREEN = "GREEN",
    YELLOW = "YELLOW",
    RED = "RED",
}

export enum NotificationType
{
    Information = "Information",
    Warning = "Warning",
    Success = "Success",
    Error = "Error",
}

export function NSBarNotification(props: NSBarNotificationPropsInner)
{
    let className = Styles["ns_" + props.color.toString().toLowerCase()];
    let type = props.type;
    let src = "";

    useEffect(() =>
    {
        const interval = setInterval(() =>
        {
            props.onChangeState();
        }, 500);
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, []);

    switch (type)
    {
        case "Error":
            src = "https://static.namirasoft.com/image/concept/close/error.svg";
            break;
        case "Success":
            src = "https://static.namirasoft.com/image/concept/close/success.svg";
            break;
        case "Warning":
            src = "https://static.namirasoft.com/image/concept/close/warning.svg";
            break;
        case "Information":
            src = "https://static.namirasoft.com/image/concept/close/info.svg";
    }

    return (
        <div id={props.id}
            className={`${Styles.ns_messenger} ${className}`}
            style={props.style}
        >
            <p className={`mb-0 ns-font-16-normal`}>{props.text}</p>
            <img
                className={Styles.ns_exit_icon}
                src={src}
                alt="exit"
                width={32}
                height={32}
                onClick={() =>
                {
                    props.onClose?.();
                }}
            />
        </div>
    )
};